import { render } from "./MsourceNav.vue?vue&type=template&id=dca86f4e&scoped=true"
import script from "./MsourceNav.vue?vue&type=script&lang=js"
export * from "./MsourceNav.vue?vue&type=script&lang=js"

import "./MsourceNav.vue?vue&type=style&index=0&id=dca86f4e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca86f4e"]])

export default __exports__